import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { ResourceManagerService } from '../services/resource-manager.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LazyLoad } from '@app/helpers/lazyload';
import { LoaderService } from '../services/loader.service';
declare const $: any;

@Injectable({ providedIn: 'root' })
export class ResourcesResolver implements Resolve<boolean> {
  constructor(
    private loaderService: LoaderService,
    private resourceManager: ResourceManagerService,
    @Inject(PLATFORM_ID) private platformId,
  ) { }
  loadResources(): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.resourceManager.loadStyles('bootstrap', 'font-awesome',
        'animate', 'owl-carousel', 'normalize', 'style',
        'responsive', 'custom-style', 'custom-responsive', 'countrySelect');
      return this.resourceManager.loadScripts('jquery').then(response => {
        this.loaderService.show();
        return this.resourceManager.loadScripts('popper', 'bootstrap','owl-carousel', 'wow', 'price', 'countrySelect');
      }).then(response => { });
    }
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    return this.loadResources();
  }
}
